import React from "react";
import { useWatch, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const AttendanceRow = ({
  field,
  index,
  control,
  errors,
  isView,
  requestType,
}) => {
  const selectedType = useWatch({
    control,
    name: `attendance_request.${index}.type`,
    defaultValue: field.type || "Both",
  });

  const maxDateTime = (() => {
    const now = new Date();
    now.setDate(now.getDate() - 1);
    now.setHours(23, 59, 59, 0);
    return now;
  })();

  return (
    <tr key={field.id}>
      <td>
        <Controller
          name={`attendance_request.${index}.type`}
          control={control}
          defaultValue={field.type || "Both"}
          render={({ field }) => (
            <select
              {...field}
              className="form-select"
              disabled={isView || requestType === "Create Attendance"}
            >
              <option value="Both">Both</option>
              <option value="Check-In">Check-In</option>
              <option value="Check-Out">Check-Out</option>
            </select>
          )}
        />
      </td>

      <td>
        <Controller
          control={control}
          name={`attendance_request.${index}.check_in`}
          rules={{
            required:
              selectedType === "Check-In" || selectedType === "Both"
                ? "Check-in required"
                : false,
          }}
          render={({ field }) => (
            <DatePicker
              selected={
                field.value &&
                moment(field.value, "DD-MM-YYYY HH:mm:ss").isValid()
                  ? moment(field.value, "DD-MM-YYYY HH:mm:ss").toDate()
                  : null
              }
              onChange={(date) => {
                const formatted = moment(date).format("DD-MM-YYYY HH:mm:ss");
                field.onChange(formatted);
              }}
              showTimeSelect
              showTimeSelectSeconds
              timeFormat="HH:mm:ss"
              dateFormat="dd-MM-yyyy HH:mm:ss"
              maxDate={maxDateTime}
              minDate={new Date(2000, 0, 1)}
              maxTime={field.value ? maxDateTime : new Date(0, 0, 0, 0, 0, 0)}
              minTime={
                field.value
                  ? new Date(0, 0, 0, 0, 0, 1)
                  : new Date(0, 0, 0, 0, 0, 0)
              }
              filterTime={(time) => {
                if (!field.value) return false;
                const hour = time.getHours();
                const minute = time.getMinutes();
                const second = time.getSeconds();
                return !(hour === 0 && minute === 0 && second === 0);
              }}
              disabled={isView || selectedType === "Check-Out"}
              className={`form-control ${
                errors?.attendance_request?.[index]?.check_in
                  ? "is-invalid"
                  : ""
              }`}
              placeholderText="dd-mm-yyyy hh:mm:ss"
            />
          )}
        />
        {errors?.attendance_request?.[index]?.check_in && (
          <p className="text-danger">
            {errors.attendance_request[index].check_in.message}
          </p>
        )}
      </td>

      <td>
        <Controller
          control={control}
          name={`attendance_request.${index}.check_out`}
          rules={{
            required:
              selectedType === "Check-Out" || selectedType === "Both"
                ? "Check-out required"
                : false,
          }}
          render={({ field }) => (
            <DatePicker
              selected={
                field.value &&
                moment(field.value, "DD-MM-YYYY HH:mm:ss").isValid()
                  ? moment(field.value, "DD-MM-YYYY HH:mm:ss").toDate()
                  : null
              }
              onChange={(date) => {
                const formatted = moment(date).format("DD-MM-YYYY HH:mm:ss");
                field.onChange(formatted);
              }}
              showTimeSelect
              showTimeSelectSeconds
              timeFormat="HH:mm:ss"
              dateFormat="dd-MM-yyyy HH:mm:ss"
              maxDate={maxDateTime}
              minDate={new Date(2000, 0, 1)}
              maxTime={field.value ? maxDateTime : new Date(0, 0, 0, 0, 0, 0)}
              minTime={
                field.value
                  ? new Date(0, 0, 0, 0, 0, 1)
                  : new Date(0, 0, 0, 0, 0, 0)
              }
              filterTime={(time) => {
                if (!field.value) return false;
                const hour = time.getHours();
                const minute = time.getMinutes();
                const second = time.getSeconds();
                return !(hour === 0 && minute === 0 && second === 0);
              }}
              disabled={isView || selectedType === "Check-In"}
              className={`form-control ${
                errors?.attendance_request?.[index]?.check_out
                  ? "is-invalid"
                  : ""
              }`}
              placeholderText="dd-mm-yyyy hh:mm:ss"
            />
          )}
        />
        {errors?.attendance_request?.[index]?.check_out && (
          <p className="text-danger">
            {errors.attendance_request[index].check_out.message}
          </p>
        )}
      </td>
    </tr>
  );
};

export default AttendanceRow;

